import axios from './api'

export function getMyCounselorProfile() {
	return axios.get('/counseling/counselor')
}

export function getMyStudents() {
	return axios.get('/counseling/counselor/students')
}

export function getMyStudent(student) {
	return axios.get('/counseling/counselor/students/' + student)
}

export function postNote(student, note) {
	return axios.post(`/counseling/counselor/students/${student}/notes`, note)
}

export function getMySummary() {
	return axios.get('/counseling/counselor/summary')
}

export function createSessionRequest(session) {
	return axios.post('/counseling/session-requests', session)
}

export function sendMessage(obj) {
	return axios.post('counselor/chat', obj)
}

export function getMessages() {
	return axios.get('counselor/chat')
}

/** Send message to selected students (saved in saas.counselor_student_messages; same table as student replies) */
export function sendMessagesToStudents({ message, student_ids, metadata }) {
	const payload = { message, student_ids }
	if (metadata != null) {
		payload.metadata = metadata
	}
	return axios.post('/counseling/counselor/messages', payload)
}
